<template>
    <label>
        Choose Scheme <strong>({{ currentScheme }})</strong>:
        <select @change="reloadSite">
            <option value="" />
            <option
                v-for="scheme in schemes"
                :key="scheme.id"
                :value="scheme.host">
                {{ scheme.theme }}
            </option>
        </select>
    </label>
</template>
<script>

export default {
    computed: {
        schemes() {
            return (this.$config.schemes || []).filter(s => s.schemeHost.length > 0).map(s => ({
                id: s.id,
                theme: s.theme,
                host: s.schemeHost[0].host,
            }))
        },

        currentScheme() {
            const current = this.schemes.find(s => s.host === location.hostname)

            return current ? current.theme : 'unknown'
        },
    },

    methods: {
        reloadSite(evt) {
            if (evt.target.value === '') return

            location.href = `http://${ evt.target.value }:8080${ location.pathname }`
        },
    },
}

</script>
